import { DailyMotion } from "./DailyMotion";
import { Facebook } from "./Facebook";
import { FilePlayer } from "./FilePlayer";
import { Mixcloud } from "./Mixcloud";
import { SoundCloud } from "./SoundCloud";
import { Streamable } from "./Streamable";
import { Twitch } from "./Twitch";
import { Vimeo } from "./Vimeo";
import { Wistia } from "./Wistia";
import { YouTube } from "./YouTube";
var players_default = [
  YouTube,
  SoundCloud,
  Vimeo,
  Facebook,
  Streamable,
  Wistia,
  Twitch,
  DailyMotion,
  Mixcloud,
  FilePlayer
];
export {
  players_default as default
};
//# sourceMappingURL=index.js.map
